import { AppSpacingOptions } from '../IMaterial';

export const initializeSpacing = (value?: AppSpacingOptions): AppSpacingOptions => {
  return value || 4;
};
